<template>
  <table class="table align-items-center mb-0">
    <thead>
      <tr>
        <th class="text-sm">Interface</th>
        <th class="text-sm">TX Power (dBm)</th>
        <th class="text-sm">RX Power (dBm)</th>
        <th class="text-sm">Bias Current (mA)</th>
        <th class="text-sm">Voltage (V)</th>
        <th class="text-sm">Temperature (°C)</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="6">
            <Skalaton />
          </td>
        </tr>
      </template>
      <template v-else-if="uplinkInfo?.ports && uplinkInfo.ports.length">
        <tr
          v-for="port in uplinkInfo.ports"
          :key="port.index"
        >
          <td class="text-sm font-weight-bold">{{ port.interface }}</td>
          <td class="text-sm" :class="getPowerClass(port.tx_power, 'tx')">
            {{ formatPower(port.tx_power) }}
          </td>
          <td class="text-sm" :class="getPowerClass(port.rx_power, 'rx')">
            {{ formatPower(port.rx_power) }}
          </td>
          <td class="text-sm">{{ formatCurrent(port.bias_current_mA) }}</td>
          <td class="text-sm">{{ formatVoltage(port.supply_voltage) }}</td>
          <td class="text-sm" :class="getTemperatureClass(port.sfp_temp)">
            {{ formatTemperature(port.sfp_temp) }}
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="6" class="text-center text-muted py-4">
            No uplink port data available
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Skalaton from '@/components/Skalaton.vue';

export default {
  name: 'BdcomGponUplinkTable',
  components: {
    Skalaton
  },
  props: {
    uplinkInfo: Object,
    loading: Boolean
  },
  methods: {
    formatPower(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} dBm`;
    },
    
    formatCurrent(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} mA`;
    },
    
    formatVoltage(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value} V`;
    },
    
    formatTemperature(value) {
      if (value === null || value === undefined) return 'N/A';
      return `${value}°C`;
    },
    
    getPowerClass(value, type) {
      if (value === null || value === undefined) return 'text-muted';
      
      if (type === 'tx') {
        // For TX power, positive values are normal for GPON, negative for uplink
        if (value > 0) return 'text-success'; // GPON TX power (positive)
        if (value > -5) return 'text-success'; // Good uplink TX power
        if (value > -10) return 'text-warning'; // Warning uplink TX power
        return 'text-danger'; // Critical uplink TX power
      } else {
        // For RX power
        if (value > -25) return 'text-success'; // Excellent RX power
        if (value > -30) return 'text-warning'; // Warning RX power
        return 'text-danger'; // Critical RX power
      }
    },
    
    getTemperatureClass(value) {
      if (value === null || value === undefined) return 'text-muted';
      
      if (value < 50) return 'text-success'; // Normal temperature
      if (value < 60) return 'text-warning'; // Warning temperature
      return 'text-danger'; // Critical temperature
    }
  }
}
</script>